var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.66671 14.4999C3.90004 14.4999 0.833374 11.4333 0.833374 7.66659C0.833374 3.89992 3.90004 0.833252 7.66671 0.833252C11.4334 0.833252 14.5 3.89992 14.5 7.66659C14.5 11.4333 11.4334 14.4999 7.66671 14.4999ZM7.66671 1.83325C4.44671 1.83325 1.83337 4.45325 1.83337 7.66659C1.83337 10.8799 4.44671 13.4999 7.66671 13.4999C10.8867 13.4999 13.5 10.8799 13.5 7.66659C13.5 4.45325 10.8867 1.83325 7.66671 1.83325Z",
    fill: "#7f4b2a",
    stroke: "#7f4b2a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6669 15.1666C14.5402 15.1666 14.4135 15.12 14.3135 15.02L12.9802 13.6866C12.7869 13.4933 12.7869 13.1733 12.9802 12.98C13.1735 12.7866 13.4935 12.7866 13.6869 12.98L15.0202 14.3133C15.2135 14.5066 15.2135 14.8266 15.0202 15.02C14.9202 15.12 14.7935 15.1666 14.6669 15.1666Z",
    fill: "#7f4b2a",
    stroke: "#7f4b2a",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#7f4b2a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7492692b25678e332274ec9c6aac8116.svg";
export { ForwardRef as ReactComponent };